<div *ngIf="!childConfig.isHidden" [style.width.px]="childConfig.css.width" class="tml-tpl-ctrl-wrap">
    <!--Job Title-->
    <div>
        <div class="tam-contact-control" tid="Relationship_Type">
            <kendo-dropdownlist [style.width.px]="childConfig.css.leftWidth" #dropDownElJobTitle
                class="contact-dropdown" [data]="jobTitleSuggestionItems" [filterable]="true"
                (filterChange)="handleFilter($event,0)" [textField]="'name'" [valueField]="'name'"
                [(ngModel)]="jobTitleSelectedItem" (focus)="dropDownElJobTitle.toggle(true)"
                (valueChange)="valueChangeJobTitle($event)" (keydown.esc)="onEnter($event)"
                (mousedown)="$event.preventDefault()" [disabled]="readOnly">
                <ng-template kendoMultiSelectHeaderTemplate>
                    <div class="popup-template-clear-header">
                        <span class="multiselect-Clear" (click)="clearJobTitleValue()">Clear</span>
                    </div>
                </ng-template>
            </kendo-dropdownlist>
        </div>
        <div *ngIf="childConfig.config.isSupportDynamic" class="label-bac" (click)="clickAddCtrol($event)">
            <label>{{childConfig.config.addlabel}}</label>
        </div>
    </div>
    <!--Company-->
    <div>
        <div class="tam-contact-control value-trash" tid="Relationship_Entity">
            <kendo-multiselect [style.width.px]="childConfig.css.rightWidth" [popupSettings]="{appendTo: 'component'}"
                #dropDownElCompany class="contact-dropdown multi-select" [data]="companySuggestionItems"
                (open)="onOpen($event)" [filterable]="true" (filterChange)="handleFilter($event,1)" [textField]="'name'"
                [valueField]="'id'" [(ngModel)]="companySelectedItem" (focus)="dropDownElCompany.toggle(true)"
                (valueChange)="valueChangeCompany($event)" (keydown.esc)="onEnter($event)" [autoClose]="false"
                [disabled]="readOnly">
                <div>
                    <ng-template kendoMultiSelectHeaderTemplate>
                        <div class="popup-template-clear-header">
                            <div class="row">
                                <div class="all-left">
                                    <span (click)="selectAll()">
                                        Select All
                                    </span>
                                </div>
                                <div class="all-right">
                                    <span class="multiselect-Clear" (click)="clearValue()">Clear</span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div>
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                        <tam-entity-dropdown-item [entity]="dataItem" [selectedItems]="companySelectedItem" *ngIf="companySuggestionItems">
                        </tam-entity-dropdown-item>

                    </ng-template>
                </div>
                <div>
                    <ng-template kendoMultiSelectFooterTemplate let-dataItem>
                        <div *ngIf="searchItem">
                            <div *ngIf="isFly && isShowCreateContact" (click)="createContact()"
                                class="dropdown-fly-item">
                                <span> {{searchItem}} (New contact)</span>
                            </div>
                            <div *ngIf="isFly && isShowCreateEntity" (click)="createEntity()" class="dropdown-fly-item">
                                <span>{{searchItem}} (New entity)</span>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </kendo-multiselect>
            <div class="trash-icon">
                <smart-icon *ngIf="childConfig.config.isCanDelete" name="trash" (click)="clickRemoveLayout($event)">
                </smart-icon>
            </div>
        </div>
    </div>
</div>